/**
 * Extrae el nombre de archivo de un header Content-Disposition.
 * Soporta filename="con espacios.pdf" y filename*=UTF-8''encoded.pdf
 */
export function filenameFromContentDisposition(disposition, fallback = 'archivo') {
  if (!disposition || typeof disposition !== 'string') {
    return fallback || 'archivo';
  }

  const mStar = /filename\*\s*=\s*(?:UTF-8''|utf-8'')([^;\n]+)/i.exec(disposition);
  if (mStar) {
    try {
      return decodeURIComponent(mStar[1].trim().replace(/^["']|["']$/g, ''));
    } catch (_) {
      return mStar[1].trim().replace(/^["']|["']$/g, '');
    }
  }

  const mQuoted = /filename\s*=\s*"((?:\\.|[^"\\])*)"/i.exec(disposition);
  if (mQuoted) {
    return mQuoted[1].replace(/\\"/g, '"');
  }

  const mPlain = /filename\s*=\s*([^;\n]+)/i.exec(disposition);
  if (mPlain) {
    return mPlain[1].trim().replace(/^["']|["']$/g, '');
  }

  return fallback || 'archivo';
}

/**
 * Elige un nombre seguro para a.download, priorizando el que conserve la extensión.
 */
export function resolveDownloadFilename(fromHeader, fallback) {
  const base = (name) => String(name || '').split(/[/\\]/).pop().trim();
  const headerName = base(fromHeader);
  const fallbackName = base(fallback) || 'archivo';
  if (!headerName) return fallbackName;
  const headerHasExt = /\.[a-zA-Z0-9]{1,15}$/.test(headerName);
  const fallbackHasExt = /\.[a-zA-Z0-9]{1,15}$/.test(fallbackName);
  if (!headerHasExt && fallbackHasExt) return fallbackName;
  return headerName;
}
